import { render } from "./commonFileTable.vue?vue&type=template&id=0616a644"
import script from "./commonFileTable.vue?vue&type=script&lang=js"
export * from "./commonFileTable.vue?vue&type=script&lang=js"

import "./commonFileTable.vue?vue&type=style&index=0&id=0616a644&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__